import { AirportConfigurationType } from '../../../backend';

export const CommonProperties = ['active'];

export const UnsharedProperties: Record<AirportConfigurationType, string[]> = {
    [AirportConfigurationType.AIRLINES]: ['name', 'codeIata', 'codeIcao', 'gateOpeningOffset', 'gateClosingOffset'],
};

export const getPropertiesListByType = (configurationType: AirportConfigurationType) =>
    UnsharedProperties[configurationType]
        ? UnsharedProperties[configurationType].concat(CommonProperties)
        : CommonProperties;
